import { render, staticRenderFns } from "./signNumber.vue?vue&type=template&id=5d8a73ec"
import script from "./signNumber.vue?vue&type=script&lang=js"
export * from "./signNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports